import { Text as HygraphTextProps } from '@/lib/types';

import HygraphRichText, {
  HygraphRichTextProps,
} from '@/components/hygraph-rich-text';

import richTextTransformer from '@/hygraph/transformers/rich-text.transformer';

export default function TextRenderer(hygraphProps: HygraphTextProps) {
  const componentProps: HygraphRichTextProps | undefined = richTextTransformer({
    heading: hygraphProps.heading || undefined,
    content: hygraphProps.richText?.raw || '',
  });
  if (!componentProps) return <></>;

  return <HygraphRichText {...componentProps} />;
}
